import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";

const items = [
  "Aktivasi otomatis",
  "Pengiriman via Email & WhatsApp",
  "Cepat",
  "Aman",
  "Praktis",
  "Tanpa ribet",
  "Support jika ada kendala aktivasi",
];

export const Advantages = () => (
  <section className="py-14 md:py-16 bg-slate-50 border-y border-slate-200/70">
    <div className="max-w-6xl mx-auto px-5 md:px-8">
      <div className="flex flex-wrap justify-center gap-3 md:gap-4">
        {items.map((item, i) => (
          <motion.span
            key={item}
            initial={{ opacity: 0, scale: 0.85 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
            className="inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-4 py-2.5 text-sm md:text-base font-semibold text-slate-700 shadow-[0_2px_12px_rgba(0,0,0,0.04)] hover:-translate-y-0.5 hover:shadow-[0_8px_20px_rgba(37,99,235,0.1)] transition-[transform,box-shadow]"
            data-testid={`advantage-chip-${i}`}
          >
            <CheckCircle2 className="w-4 h-4 text-emerald-600 shrink-0" strokeWidth={2.5} />
            {item}
          </motion.span>
        ))}
      </div>
    </div>
  </section>
);
